<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Soal Pilihan Ganda",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "No Urut", name: "-" },
      { width: "auto", label: "Kategori", name: "-" },
      { width: "auto", label: "Versi Soal", name: "-" },
      { width: "450px", label: "Pertanyaan", name: "pertanyaan" },
      { width: "auto", label: "Tipe", name: "-" },
      { width: "auto", label: "Gambar", name: "-" },
      { width: "auto", label: "Pilihan A", name: "-" },
      { width: "auto", label: "Pilihan B", name: "-" },
      { width: "auto", label: "Pilihan C", name: "-" },
      { width: "auto", label: "Pilihan D", name: "-" },
      { width: "auto", label: "Kunci Jawaban", name: "-" },
      // { width: 'auto', label: 'Timer', name: '-' },
      { width: "160px", label: "Status Review", name: "-" },
      { width: "250px", label: "Catatan Review", name: "-" },
      { width: "175px", label: "Aksi", name: "-" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      isWriteSetup: localStorage.getItem("isWrite"),
      isReadSetup: localStorage.getItem("isRead"),
      title: "Soal Pilihan Ganda",
      items: [
        {
          text: "Master Soal",
          href: "/",
        },
        {
          text: "Soal Pilihan Ganda",
          active: true,
        },
      ],
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      columns: columns,
      sortKey: "kompetensi_idkompetensi",
      sortOrders: sortOrders,

      currentTablePage: "",
      tableFilter: {
        status: 1,
        status_review: "",
        search: "",
        page: 1,
        per_page: 10,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      notifJawabanKosong: null,
      showModalPreview: false,
      previewUrl: "",
      hasRevisionSoal: false,
      kompetensiStatusReview: "",
    };
  },
  mounted() {
    this.getKompetensi();
    if (!(this.isWriteSetup || this.isWriteSetup == 1)) {
      this.columns.pop();
    }
    this.getData();
    this.getJawabanKosong();
    this.checkHasRevisionSoal();
  },
  methods: {
    async checkHasRevisionSoal() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/kompetensi/" +
            this.idKompetensi +
            "/has-revision",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      if (data) {
        this.hasRevisionSoal = data.hasRevision === true;
        this.kompetensiStatusReview = data.status_review || "PENDING";
      }
    },
    async getKompetensi() {
      // let idKompetensi = this.$router.params;
      console.log(this.$route.params.id);
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    async kirimHasilReview() {
      Swal.fire({
        title: "Mohon tunggu",
        text: "Mengecek apakah ada data yang perlu untuk direview di semua tipe soal pada kompetensi ini...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const data = await axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/kompetensi/" +
            this.idKompetensi +
            "/kirim-hasil-review",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: "Gagal mengirim hasil review.",
          });
          return false;
        });

      if (data) {
        if (data.updated) {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Hasil review berhasil dikirim.",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            this.$router.push({ name: "review-soal-tools-asesmen" });
          });
        } else {
          Swal.fire({
            icon: "info",
            title: "Tidak Ada Perubahan",
            text: data.message || "Tidak ada soal yang perlu direview.",
          });
        }
      }
    },
    async getJawabanKosong() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/kompetensi/" +
          this.idKompetensi +
          "/soal/jawaban-kosong",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        params: {
          id_kompetensi: this.idKompetensi,
          level_kompetensi: this.kompetensi.level_kompetensi_idlevel_kompetensi,
          tipe: "Pilihan Ganda",
        },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.notifJawabanKosong = data?.jawaban_kosong;
      }
    },
    async getData(resetPage = true) {
      if (resetPage) {
        this.tableFilter.page = 1; // Reset to first page when fetching new data
      }
      this.isLoading = true;
      const url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "review-soal/tools-asesmen/kompetensi/" +
        this.idKompetensi +
        "/soal-pilihan-ganda";

      const data = await axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            Accept: "Application/json",
          },
          params: this.tableFilter,
        })
        .then((response) => {
          let responseData = response.data;

          this.pagination.lastPage = responseData.data.last_page;
          this.pagination.currentPage = responseData.data.current_page;
          this.pagination.total = responseData.data.total;
          this.pagination.lastPageUrl = responseData.data.last_page_url;
          this.pagination.nextPageUrl = responseData.data.next_page_url;
          this.pagination.prevPageUrl = responseData.data.prev_page_url;
          this.pagination.from = responseData.data.from;
          this.pagination.to = responseData.data.to;
          this.pagination.links = responseData.data.links;
          this.currentTablePage = responseData.data.current_page;

          return responseData.data.data;
        })
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });

      if (data) {
        this.table_data = data;
      }
      this.isLoading = false;
    },
    statusReviewBadgeClass(status) {
      switch (status) {
        case "COMPLETED":
          return "bg-success";
        case "REVISION":
          return "bg-danger";
        case "REPAIRED":
          return "bg-primary";
        case "REVIEWED":
          return "bg-info";
        case "PENDING":
          return "bg-secondary";
        default:
          return "bg-secondary";
      }
    },
    statusReviewIcon(status) {
      switch (status) {
        case "COMPLETED":
          return "fa fa-check-circle";
        case "REVISION":
          return "fa fa-pen";
        case "REPAIRED":
          return "fa fa-wrench";
        case "REVIEWED":
          return "fa fa-eye";
        default:
          return "fa fa-clock";
      }
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getData(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    updateData(row) {
      this.$router.push({
        name: "review-soal-pg-update",
        params: { id: this.idKompetensi, idsoal: row.idsoal },
      });
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalPreview = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title d-flex align-items-center gap-2">
                    Soal Pilihan Ganda
                    <span
                      class="badge bg-gradient rounded-pill py-1 px-3 fw-bold text-nowrap"
                      :class="statusReviewBadgeClass(kompetensiStatusReview)"
                    >
                      <i
                        :class="statusReviewIcon(kompetensiStatusReview)"
                        class="me-1"
                      ></i>
                      {{ kompetensiStatusReview || "PENDING" }}
                    </span>
                  </div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{ kompetensi?.nama_kompetensi || "-" }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'review-soal-tools-asesmen' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i>
                    Kembali
                  </router-link>
                  <button
                    v-if="hasRevisionSoal"
                    class="btn btn-primary btn-sm"
                    @click="kirimHasilReview()"
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    Kirim Hasil Review
                  </button>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <div class="row mb-2">
                  <div class="form-group col-md-3">
                    <label for="filterStatusReview">Status Review</label>
                    <select
                      class="form-select"
                      id="filterStatusReview"
                      v-model="tableFilter.status_review"
                      @change="getData()"
                    >
                      <option value="">SEMUA STATUS</option>
                      <option value="PENDING">PENDING</option>
                      <option value="REVIEWED">REVIEWED</option>
                      <option value="REVISION">REVISION</option>
                      <option value="COMPLETED">COMPLETED</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex align-items-end">
                <table>
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="getData()"
                />
              </div>
            </div>
            <div class="row my-0" v-if="notifJawabanKosong">
              <div class="col">
                <p class="text-danger fw-bold my-0">
                  * Terdapat soal dengan no urut :
                  {{ notifJawabanKosong }} belum memiliki jawaban
                </p>
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="isLoading">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr v-else v-for="(row, key) in table_data" :key="key">
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}{{ key + 1 }}.
                      </span>
                    </td>
                    <td>{{ row.nomor_urut || "-" }}</td>
                    <td>{{ row.soal_text || "-" }}</td>
                    <td>{{ row.versi_soal || "-" }}</td>
                    <td>
                      <div v-html="row.pertanyaan"></div>
                    </td>
                    <!-- <td>{{ row.pertanyaan || "-" }}</td> -->
                    <td>{{ row.tipe || "-" }}</td>
                    <td>
                      <div class="container-image" v-if="row.soal_image">
                        <img
                          v-if="row.soal_image"
                          :src="link + row.soal_image"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="previewImage(link + row.soal_image)"
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <template v-if="row.jawaban_a && row.jawaban_a.startsWith('/storage/file_manager')">
                        <button class="btn btn-outline-info btn-sm" @click="previewImage(link + row.jawaban_a)">
                          <i class="fa fa-image me-1"></i> Preview
                        </button>
                      </template>
                      <template v-else>{{ row.jawaban_a || "-" }}</template>
                    </td>
                    <td>
                      <template v-if="row.jawaban_b && row.jawaban_b.startsWith('/storage/file_manager')">
                        <button class="btn btn-outline-info btn-sm" @click="previewImage(link + row.jawaban_b)">
                          <i class="fa fa-image me-1"></i> Preview
                        </button>
                      </template>
                      <template v-else>{{ row.jawaban_b || "-" }}</template>
                    </td>
                    <td>
                      <template v-if="row.jawaban_c && row.jawaban_c.startsWith('/storage/file_manager')">
                        <button class="btn btn-outline-info btn-sm" @click="previewImage(link + row.jawaban_c)">
                          <i class="fa fa-image me-1"></i> Preview
                        </button>
                      </template>
                      <template v-else>{{ row.jawaban_c || "-" }}</template>
                    </td>
                    <td>
                      <template v-if="row.jawaban_d && row.jawaban_d.startsWith('/storage/file_manager')">
                        <button class="btn btn-outline-info btn-sm" @click="previewImage(link + row.jawaban_d)">
                          <i class="fa fa-image me-1"></i> Preview
                        </button>
                      </template>
                      <template v-else>{{ row.jawaban_d || "-" }}</template>
                    </td>
                    <td class="text-center">{{ row.kunci_jawaban || "-" }}</td>
                    <!-- <td>{{ row.timer || '-' }}</td> -->
                    <td class="text-center">
                      <span
                        class="badge bg-gradient rounded-pill py-2 px-4 fw-bold text-nowrap w-100"
                        :class="statusReviewBadgeClass(row.status_review)"
                      >
                        <i :class="statusReviewIcon(row.status_review)" class="me-1"></i>
                        {{ row.status_review || "PENDING" }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="d-inline-block text-truncate"
                        style="max-width: 220px"
                        :title="row.catatan_review"
                      >
                        {{ row.catatan_review || "-" }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex gap-2" v-if="isWriteSetup || isWriteSetup == 1">
                        <button
                          class="btn btn-primary btn-sm w-100"
                          @click="updateData(row)"
                        >
                          <i class="fa fa-wrench me-1"></i>
                          Setup
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>

            <pagination :pagination="pagination" @to-page="toPage"></pagination>

            <hr class="five-dashes" />
            <div class="mt-2 d-flex flex-column align-items-end">
              <table class="table table-borderless mb-0 w-auto align-middle">
                <thead>
                  <tr>
                    <th colspan="3" class="text-end fw-bold p-2">
                      Keterangan Status
                      <i class="fas fa-info-circle text-primary ms-1"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini belum direview</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-secondary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-clock me-1"></i> PENDING
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini ditandai perlu revisi, menunggu diperbaiki di Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-danger py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-pen me-1"></i> REVISION
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah dikirim ke Monitoring Review untuk diperbaiki</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-info py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-eye me-1"></i> REVIEWED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah diperbaiki di Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-primary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-wrench me-1"></i> REPAIRED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah di-approve dan dinyatakan selesai</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-success py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-check-circle me-1"></i> COMPLETED
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>

  <b-modal
    v-model="showModalPreview"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="previewUrl" class="image" />
    </div>
  </b-modal>
</template>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}
</style>
